import React from 'react';

import { Button } from 'ui-components/components/button';
import { TrackingNumberLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const TrackingNumber = () => {
  const { trackingNumber, trackingUrl } = useFulfillmentDisplayContext();
  return (
    <ReadonlyField label={TrackingNumberLabel}>
      {trackingUrl ? (
        <Button href={trackingUrl} theme='link'>
          {trackingNumber}
        </Button>
      ) : (
        trackingNumber
      )}
    </ReadonlyField>
  );
};
